export default __webpack_public_path__ + "static/media/screenshot3.7212b544.jpg";